import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bd858f0c")

_pushScopeId("data-v-bd858f0c")
const _hoisted_1 = { class: "fill" }
const _hoisted_2 = { class: "px-16 py-10 f-sm f-medium" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_TheMarketList = _resolveComponent("TheMarketList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createBlock("a", {
          key: tab.value,
          class: ["toggle__line-btn mr-4 p-4", {active: _ctx.active === index}],
          onClick: ($event: any) => (_ctx.change(index))
        }, [
          _createVNode(_component_t, {
            path: tab.label
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(tab.labelDefault), 1)
            ]),
            _: 2
          }, 1032, ["path"])
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_TheMarketList, { list: _ctx.items }, null, 8, ["list"])
  ]))
})